"use strict";

exports.__esModule = true;
exports.default = void 0;
var _styledComponents = require("styled-components");
var _layout = require("../../layout");
const getDisplay = (inline, force) => (0, _styledComponents.css)(["display:", ";"], ((0, _layout.isDefined)(inline) || force) && (inline ? "inline-grid" : "grid"));
var _default = getDisplay;
exports.default = _default;